import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface LogoProps {
  className?: string;
}

export default function Logo({ className = '' }: LogoProps) {
  const location = useLocation();

  const handleClick = (e: React.MouseEvent) => {
    if (location.pathname === '/') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Link 
      to="/" 
      className={`flex items-center ${className}`}
      onClick={handleClick}
      aria-label="Return to homepage"
    >
      <img 
        src="/coin-logo.png" 
        alt="DiversiCoin" 
        className="h-10 w-10"
      />
    </Link>
  );
}